import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { Router } from '@angular/router';
import { ServiceStateEnum } from '@mwe/constants';
import { BasicCardComponent } from '../basic-card/basic-card.component';
import { NgClass } from '@angular/common';
import { TranslateDirective } from '@ngx-translate/core';
import { PreLoadDataComponent } from '../../pre-load-data/pre-load-data.component';
import { ButtonLinkComponent } from '../../buttons/button-link/button-link.component';
import { ButtonComponent } from '../../buttons/button/button.component';

@Component({
  selector: 'mwe-card-with-icon-and-button',
  templateUrl: './card-with-icon-and-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BasicCardComponent, NgClass, TranslateDirective, PreLoadDataComponent, ButtonLinkComponent, ButtonComponent],
})
export class CardWithIconAndButtonComponent {
  cardId = input<string>();
  iconClass = input<string>();
  iconImage = input<string>();
  titleLabel = input<string>();
  ctaButtonLabel = input<string>();
  ctaButtonCss = input<string>();
  ctaButtonDataTest = input<string>('card-with-icon-and-button-button');
  ctaButtonState = input<ServiceStateEnum>(ServiceStateEnum.SUCCESS);
  ctaButtonStateErrorMessage = input<string>();
  isCtaButtonLink = input<boolean>(true);
  isCtaButtonDisabled = input<boolean>(false);
  route = input<string>();
  isExternalRoute = input<boolean>(false);
  ctaButtonClicked = output<void>();

  private router = inject(Router);

  cardClicked(): void {
    if (!this.route()) return;
    if (!this.isExternalRoute()) {
      this.router.navigateByUrl(this.route());
      return;
    }

    window.open(this.route(), '_blank');
  }
}
